import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import api from "../api";

const IndicadoresPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Determinar as abas disponíveis com base no perfil do usuário
  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const response = await api.get("/usuarios/me");
        const isAdminUser = response.data.perfil === "ADMINISTRADOR";

        // Definir as abas visíveis
        const availableTabs = [
          { label: "Dashboard", route: "/indicadores/dashboard" },
          {
            label: "Lançamento",
            route: "/indicadores/lancamento",
          },
          isAdminUser && {
            label: "Auditoria",
            route: "/indicadores/auditoria",
          },
          isAdminUser && {
            label: "Dados Consolidados",
            route: "/indicadores/consolidados",
          },
          isAdminUser && {
            label: "Exportar",
            route: "/indicadores/exportar",
          },
        ].filter(Boolean); // Remove valores `false` ou `null`

        setTabs(availableTabs);

        // Determinar a aba selecionada com base na rota atual
        const currentTab = availableTabs.findIndex((tab) =>
          location.pathname.includes(tab.route.split("/").pop())
        );
        setSelectedTab(currentTab === -1 ? 0 : currentTab); // Define Dashboard como padrão
      } catch (error) {
        console.error("Erro ao buscar o perfil do usuário:", error);
      }
    };

    fetchPerfil();
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(tabs[newValue].route);
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ marginTop: 2 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default IndicadoresPage;
